module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-viewer",
    class: {
      loaderAnimationIn: _vm.show
    },
    attrs: {
      "id": "print-modal"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "loader-contents"
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('h2', {
    staticClass: "loader-title"
  }, [_vm._v(_vm._s(_vm.$t('heading.title')))]), _vm._v(" "), _c('div', {
    staticClass: "print-preview",
    attrs: {
      "id": "printable-document"
    }
  }, [_c('div', {
    staticClass: "print-preview-heading"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/instamaps-v2-logo-flat.png",
      "alt": "Logo Instamaps"
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('heading.author')) + ": " + _vm._s(_vm.author))])]), _vm._v(" "), _c('div', {
    staticClass: "print-preview-body"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl
    }
  }), _vm._v(" "), _c('textarea', {
    attrs: {
      "id": "printable-document-notes",
      "placeholder": _vm.$t('body.notes')
    }
  })]), _vm._v(" "), (_vm.isAuthorEuroregio()) ? _c('div', {
    staticClass: "print-preview-footer2"
  }, [_c('img', {
    staticClass: "print-preview-logo",
    attrs: {
      "src": "/static/img/logo_EPM.jpg",
      "alt": "Euroregió"
    }
  })]) : _c('div', {
    staticClass: "print-preview-footer"
  }, [_c('img', {
    staticClass: "print-preview-logo",
    attrs: {
      "src": "/static/img/icgc-logo.png",
      "alt": "Institut Cartogràfic i Geològic de Catalunya"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "big-button background-green",
    on: {
      "click": function($event) {
        _vm.printTemplate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.print')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-bar"
  }, [_c('div', {
    staticClass: "bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c00b569"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/map-viewer/components/print-modal/print-modal.vue
// module id = 129
// module chunks = 0